import { KernelClient } from "@cfg/kernel/worker";

let client: KernelClient | undefined;

/** One client (two workers) per page. */
export function getKernelClient(): KernelClient {
  client ??= new KernelClient(() => new Worker(new URL("./geometry.worker.ts", import.meta.url), { type: "module", name: "geometry" }));
  return client;
}
